export const SERVICE_CODE = 'DEAL' + '_LOSS' + '_MOTIVES' + '_SERVICE';
